import { Component, OnDestroy } from '@angular/core';
import { BlogEntry } from '../blog/blog-entry';
import { BlogEntryStore } from '../blog/blog-entry-store';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.css'],
    standalone: false
})
export class NewsComponent implements OnDestroy {
  public entries: BlogEntry[];
  public lookBack: LookBack[];

  public sub: Subscription;

  constructor(blogEntryStore: BlogEntryStore) {
    this.sub = blogEntryStore.entries
      .subscribe(entries => this.updateEntries(entries));
  }

  ngOnDestroy() {
    this.sub.unsubscribe()
  }

  private updateEntries(entries) {
    const sliceAt: number = 5;
    this.entries = entries.slice(0, sliceAt);
    this.lookBack = this.getLookBacks(entries, sliceAt);
  }

  private getLookBacks(entries, skip: number = 0): LookBack[] {
    return entries
      .slice(skip)
      .reduce((previous, current) => {

        let lookbackKey = this.getLookBackKey(current.updated.$t);

        let currentLookBack = previous.find(x => x.key === lookbackKey);

        if (!currentLookBack) {
          var d = new Date(current.updated.$t);

          currentLookBack = {
            "key": lookbackKey,
            "monthName": this.getMonthName(d),
            "year": d.getFullYear().toString(),
            "entry": []
          };

          previous.push(currentLookBack);
        }

        currentLookBack.entry.push(current);

        return previous;
      }, new Array<LookBack>());
  }

  private getMonthName(d: Date): string {
    const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return month[d.getMonth()];
  }

  private getLookBackKey(dateString: string): string {
    let d = new Date(dateString);
    return `${d.getFullYear()}-${('0' + d.getMonth()).slice(-2)}`
  }

  public getBlogEntryLink(entry: BlogEntry): string {
    let link = entry.link
      .find(v => v.rel === 'alternate');
    return link!.href;
  }
}

interface LookBack {
  key: string;
  monthName: string;
  year: string;
  entry: Array<BlogEntry>;
}
